import { UserType } from "@mcleod/core";
import { DataSource } from "@mcleod/components";
import { AutogenLayoutUserTableLmeUser } from "./autogen/AutogenLayoutUserTableLmeUser";
import { UserTableController  } from "./UserTableController";
import { UserTableLayout } from "./UserTableLayout";

export class UserTableLmeUser extends AutogenLayoutUserTableLmeUser implements UserTableLayout {
    public getSourceUsers(): DataSource {
        return this.sourceUserSettings;
    }

    public getUserType(): UserType {
        return UserType.LME;
    }

    override onLoad(): void | Promise<void> {
        new UserTableController(this);
    }
}
